import { setOptions } from '@googlemaps/js-api-loader';

export default {
  /** @param {Object} app */
  async install(app) {
    setOptions({
      key: import.meta.env.GOOGLE_MAPS_JS_API_KEY,
      v: 'weekly',
      region: app.region || 'DE',
    });
  }
}
